export default __webpack_public_path__ + "static/media/IMG_1064.a05c5c61.jpg";